import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {PowerSelect} from 'react-power-select';

const CustomOptionComponent = ({ option }) => (
<div>
  <strong>{option.company.short_name}</strong> - <span>{option.name}</span>
</div>
);

export default class CustomersPowerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      customers: props.customersAll || [],
      defaultValue: props.defaultValue || '',
      selectedOption: props.selectedOption || null,
      url: "/api/v1/portal/customers/all/for-dropdown-menu",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps){
    if (this.props.selectedOption !== prevProps.selectedOption && this.props.jobId) {
      const { selectedOption } = this.props;
      this.setState(prevState => ({
        selectedOption: selectedOption,
        job: {
          ...prevState.job,
          id: this.props.jobId
        }
      }), () => {
        this.props.handleCustomerSelection(selectedOption);
      });
    }
  }

  componentDidMount() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          customers: response,
          isLoading: false
        })
      });
    });
  }

  handleChange({ option }) {
    this.setState(
      {
        selectedOption: option,
      },
      () => {
        this.props.handleCustomerSelection(option);
      }
    );
  }

  render() {
    return (
      <PowerSelect
        options={this.state.customers}
        optionLabelPath="name"
        selected={this.state.selectedOption}
        selectedOption={this.state.selectedOption}
        onChange={this.handleChange}
        placeholder="-- select a Customer -- "
        optionComponent={<CustomOptionComponent />}
        required
        />
    )
  }
}
